export const WORKLOG_PRINT_QUERY = {
  printAllImgsOnSheet: 'printAllImgsOnSheet',
  printSingleImgOnSheet: 'printSingleImgOnSheet',
  printSheetsWithImg: 'printImg',
};
